import { z } from 'zod';
import { TimeZone, Uuid } from './common.js';
/** Module `remote-site` (docs/modules/remote-site.md). Owner: task S25. The site row itself is a `sites` row with isRemote = true. */
export const RemoteSiteCreate = z.object({
    name: z.string().trim().min(1).max(80).default('Working remotely'),
    timeZone: TimeZone.optional(),
});
export const RemoteSiteUpdate = z.object({ name: z.string().trim().min(1).max(80).optional(), timeZone: TimeZone.optional() });
export const RemoteSiteGroupSettings = z.object({
    /** Members of this group may sign in to the tenant's remote site(s) from the Companion app, portal or API. */
    allowed: z.boolean().default(false),
});
export const RemoteSiteTenantSettings = z.object({
    /** Most remote sites a tenant may have (0 = no limit). */
    maxRemoteSites: z.number().int().min(0).default(1),
    /** Remote-site sign-ins store the phone's location only if the group stores locations AND this is on. */
    storeLocation: z.boolean().default(false),
});
/** What other modules ask (sites/service-p3.ts): remote sites are left out of evacuations, kiosks, displays and occupancy. */
export const RemoteSiteSummary = z.object({ id: Uuid, name: z.string(), timeZone: TimeZone });
//# sourceMappingURL=remote-site.js.map